import { defineModule } from '@core/modules';
import { ModulePath, ModuleTitle } from '@common/types';
import DocumentsSent from './containers';

export default defineModule({
  title: ModuleTitle.DocumentsSent,
  path: ModulePath.DocumentsSent,
  component: DocumentsSent
});
